import styled from "@emotion/styled";

export const RadialGrowBackGround = styled.div`
  background: radial-gradient(
     circle at center,
    rgba(52, 152, 219, 0.7) 0%,
    rgba(52, 152, 219, 0.5) 30%,
    rgba(52, 152, 219, 0.7) 60%,
    rgba(255, 255, 255, 0.2) 100%
  );
  position: absolute;
  top: ${({ topPosition }) => topPosition || "50%"};
  left: ${({ leftPosition }) => leftPosition || "40%"};
  width: 5%;
  height: 20%;
  border-radius: 50%;
  z-index: -1;
  filter: blur(30px);
  animation: moveAround ${({ animeDuration }) => animeDuration || "5s"} ease-in-out infinite alternate;
  animation-delay: ${({ animeDelay }) => animeDelay || "0s"};


  @keyframes moveAround {
    0% {
      transform: translate(0, 0) scale(1);
    }
    25% {
      transform: translate(60%, -40%) scale(1.1);
    }
    50% {
      transform: translate(120%, 20%) scale(1.1);
    }
    75% {
      transform: translate(60%, 80%) scale(0.6);
    }
    100% {
      transform: translate(0, 0) scale(1.9);
    }
  }
`;
